import React from 'react';
import './Rector.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const Rector = () => {
  return (
    <div className="rector-page">
      <Navbar />
      
      <div id="rector-container">
        <div id="rector-page-header">
          <h1>The Rector</h1>
          <p className="rector-subtitle">
            Rayalaseema University
          </p>
          <div id="rector-header-underline"></div>
        </div>
        
        <div id="rector-main-profile">
          <div id="rector-image">
            <img src="/person/ntk-profile.jpeg" alt="Prof. N.T.K. Naik" />
          </div>
          
          <div id="rector-details">
            <h2>Prof. N.T.K. Naik</h2>
            <p id="rector-title">Rector & Professor of Economics</p>
            
            <div id="rector-info">
              <p><strong>Full Name:</strong> Nenivath T.K. Naik</p>
              <p><strong>Born:</strong> September 1, 1963, G.B. Thanda, Orvakal (M) Panyam, Kurnool (D), A.P.</p>
              <p><strong>Education:</strong> M.A. (Economics, 1986, S.V. University), Ph.D. (Economics, 1998, S.K. University)</p>
              <p><strong>Google Scholar:</strong> Citations: 60, h-Index: 4, i10-Index: 3</p>
            </div>
          </div>
        </div>

        <div id="rector-content">
          <div className="rector-section">
            <h3>Current & Key Administrative Positions (18 Years 8 Months as Professor)</h3>
            <div className="rector-career-list">
              <p><strong>Vice Chancellor (I/C):</strong> Rayalaseema University, July 2024 to February 2025</p>
              <p><strong>Rector:</strong> Rayalaseema University, February 2024 to till date</p>
              <p><strong>Registrar:</strong> Rayalaseema University, 4½ Years</p>
              <p><strong>Principal:</strong> Rayalaseema University, 2 Years</p>
              <p><strong>Dean of Examinations:</strong> (PG & UG) Rayalaseema University</p>
              <p><strong>Director:</strong> Directorate of Distance Education, Rayalaseema University</p>
              <p><strong>Dean:</strong> Humanities & Social Sciences, Rayalaseema University</p>
              <p><strong>Warden:</strong> About 14 years (Both Men & Women Hostels, PG Center & Rayalaseema University)</p>
            </div>
          </div>

          <div className="rector-section">
            <h3>Awards & Recognition</h3>
            <ul>
              <li><strong>2013:</strong> State Government "Meritorious Teacher Award" by Andhra Pradesh</li>
              <li><strong>2010 & 2011:</strong> Commendation Award from District Collector & Magistrate, Kurnool District</li>
              <li><strong>2017:</strong> Bharat Ratna Mother Teresa Gold Model Award from Global Economic Progress and Research Association, New Delhi</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Academic Career Journey</h3>
            <div className="rector-career-list">
              <p><strong>1989-1992:</strong> Lecturer, S.V. University (Permanent)</p>
              <p><strong>1992-1997:</strong> Lecturer, S.K. University (Permanent)</p>
              <p><strong>1997-1998:</strong> Sr. Lecturer, S.K. University (Permanent)</p>
              <p><strong>1998-2006:</strong> Associate Professor, S.K. University (Permanent)</p>
              <p><strong>2006-2009:</strong> Professor, S.K. University (Permanent)</p>
              <p><strong>2009-2012:</strong> Professor & Registrar, Rayalaseema University (Permanent)</p>
              <p><strong>2012-2014:</strong> Professor & Principal, Rayalaseema University (Permanent)</p>
              <p><strong>2014-2016:</strong> Professor & Dean (Exams), Director (DDE), Rayalaseema University</p>
              <p><strong>2016-2019:</strong> Professor, Rayalaseema University</p>
              <p><strong>2019-Present:</strong> Professor & Chairman BOS, Rayalaseema University</p>
            </div>
          </div>

          <div className="rector-section">
            <h3>Professional Training & Development</h3>
            <ul>
              <li><strong>Aug-Sep 1991:</strong> Week Orientation Course, S.V. University, Tirupathi</li>
              <li><strong>Feb-Mar 1995:</strong> Three Week Refresher Course in Economics, S.K. University, Anantapur</li>
              <li><strong>Feb-Mar 1999:</strong> Three Week Refresher Course in Economics, S.K. University, Anantapur</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Research Achievements</h3>
            <div className="rector-stats">
              <span><strong>10</strong> Ph.D. Awarded</span>
              <span><strong>3</strong> M.Phil Awarded</span>
              <span><strong>31</strong> Research Papers Published</span>
              <span><strong>3</strong> Books Published</span>
              <span><strong>52</strong> Conferences Attended</span>
              <span><strong>35</strong> Years Teaching Experience</span>
            </div>
          </div>

          <div className="rector-section">
            <h3>Ph.D. Scholars Supervised</h3>
            <ul>
              <li>S. Mansoor Rahman (Sri Krishnadevaraya University, 2005)</li>
              <li>K.G. Mallikarjuna (Sri Krishnadevaraya University, 2010)</li>
              <li>T. Naganna (Sri Krishnadevaraya University, 2011)</li>
              <li>B. Madhava Reddy (Sri Krishnadevaraya University, 2011)</li>
              <li>K.C.V. Swamy (Sri Krishnadevaraya University, 2009)</li>
              <li>Y. Maddilety (Sri Krishnadevaraya University, 2012)</li>
              <li>K. Venkateswara Rao (Rayalaseema University, 2012)</li>
              <li>B.N. Surekha (Sri Krishnadevaraya University, 2018)</li>
              <li>Y.Narashimhulu</li>
              <li>V.Padhma</li>

            </ul>
          </div>

          <div className="rector-section">
            <h3>Books Published</h3>
            <ul>
              <li><strong>Urbanisation of India</strong> - Serials Publications, New Delhi (ISBN: 81-8387-078-3)</li>
              <li><strong>Economic Development on India - Health and Social Issues</strong> - Global Research Publications, New Delhi (ISBN: 978-81-89630-35-5)</li>
              <li><strong>Rural Development</strong> - Spectrum Publishing House, Hyderabad (ISBN: 978-93-93196-99-6)</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Research Projects</h3>
            <ul>
              <li><strong>UGC Major Project (3 Years):</strong> A Study on Socio-Economic conditions of Primitive (Chenchus) Tribes in A.P. (₹3,50,500)</li>
              <li><strong>ICSSR Major Project (Ongoing):</strong> Impact of Self Help Groups on Women Empowerment in Andhra Pradesh (₹4 Lakhs)</li>
              <li><strong>DRDA Minor Project (Completed):</strong> DRDA Projects (₹0.9 Lakhs)</li>
              <li><strong>SMPP&C Minor Project (Completed):</strong> Rehabilitation of Child Labour (₹0.9 Lakhs)</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Subjects Taught at Postgraduate Level</h3>
            <ul>
              <li>Macro Economics</li>
              <li>Research Methodology</li>
              <li>Regional Economics, Area Planning and Regional Development</li>
              <li>Agriculture Economics</li>
              <li>Indian Economic Policy</li>
              <li>Statistical Methods</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>National Seminars Organized</h3>
            <ul>
              <li><strong>March 28-29, 2014:</strong> National Seminar on "Women Empowerment in the Era of Globalisation" (ICSSR Sponsored)</li>
              <li><strong>May 13-22, 2014:</strong> Ten Days Training Program for Research Scholars in Social Sciences on "Research Methodology" (ICSSR Sponsored)</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Professional Memberships</h3>
            <ul>
              <li>Member - Indian Economics Association</li>
              <li>Member - A.P. Economics Association</li>
              <li>Executive Body Member - SRK PG College (A), Nandyal</li>
              <li>Executive Body Member - Osmania College (A), Kurnool</li>
              <li>College Development Committee Member - KVR Govt. College, Kurnool</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Social Welfare Activities</h3>
            <ul>
              <li><strong>President:</strong> Tribal Welfare Association, Kurnool District (10+ Years)</li>
              <li><strong>President:</strong> S.C., S.T., B.C., and Minority Welfare Association, Kurnool District (2 Years)</li>
              <li><strong>Vice President:</strong> S.C., S.T. Gazetted Officers Employees Association, Kurnool</li>
              <li>Organized Free Coaching Programmes for Group-I Services Candidates</li>
            </ul>
          </div>

          <div className="rector-section">
            <h3>Additional Responsibilities</h3>
            <ul>
              <li>Advisory Committee Member for ICET 2009 Exam</li>
              <li>Regional Coordinator for ICET, LAWCET Entrance Exams</li>
              <li>Convener for RUPGCET 2013 and RUPGCET 2014</li>
              <li>Selection Committee Member - DRDA, Govt. Bodies and Banking Sector</li>
              <li>Consultant - Andhra Bank, Society for Man Power Planning and Consultancy</li>
            </ul>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Rector;